import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { QuestionnaireApiService } from '@nx-ratenow/dashboard/client/questionnaire/data-acces';
import { catchError, map, of, switchMap } from 'rxjs';
import { setConfigConditional, setErrorLoadingQuestion, setSelectorsByQuestionnaire } from './conditional.actions';
import { ConfigState } from './conditional.state';

@Injectable()
export class ConditionalEffects {
  selectorConditional$ = createEffect(() =>
    this.actions$.pipe(
      ofType(setConfigConditional),
      switchMap((action: { config: ConfigState }) => {
        return this.questionnaireApiService.getQuestionCondition(action.config.id).pipe(
          map((questionList) =>
            setSelectorsByQuestionnaire({
              selectors: questionList
            })
          ),
          catchError((_) => of(setErrorLoadingQuestion()))
        );
      })
    )
  );

  constructor(
    private actions$: Actions,
    private questionnaireApiService: QuestionnaireApiService
  ) {}
}
